import PropTypes from 'prop-types';
import React from 'react';
import TruncatableText from '../../Elements/TruncatableText/TruncatableText';
import CardHeader from '../CardHeader/CardHeader';

import './RulesCard.scss';

export default class RulesCard extends React.PureComponent {
    constructor(props) {
        super();
        this.state = {
            isDisplayTextTruncated: true,
        };
    }

    static propTypes = {
        /**
         * text that will be displayed as rules
         */
        displayText: PropTypes.string.isRequired,
    };

    static defaultProps = {
        displayText: '',
    };

    handleShowMoreOrLessClick = () => {
        this.setState({
            isDisplayTextTruncated: !this.state.isDisplayTextTruncated,
        });
    };

    render() {
        const { isDisplayTextTruncated } = this.state;
        const { displayText } = this.props;
        return (
            <div className="component-Groups-RulesCard">
                <CardHeader cssClass="rules-header">Group rules</CardHeader>
                <TruncatableText
                    displayText={displayText}
                    isDisplayTextTruncated={isDisplayTextTruncated}
                    handleShowMoreOrLessClick={this.handleShowMoreOrLessClick}
                    showMoreBtnText={'Read more'}
                    showLessBtnText={null}
                    truncatedAtIndex={479}
                />
            </div>
        );
    }
}
